// @ts-nocheck
import React from "react";
import { Container } from "./styles";

// "ROSA DA COSTA VARGEM" -> "Rosa"
const primeiroNome = (nome) => {
  const primeiro = nome?.trim().split(/\s+/)[0] || "";
  return primeiro.charAt(0).toUpperCase() + primeiro.slice(1).toLowerCase();
};

// "Karla (PT639914/1)", "Karla (PT639914/1) e Vitor (PT639914/3)", ...
const listarPedidos = (pedidos) => {
  const itens = pedidos.map((p) => {
    const nome = primeiroNome(p?.applicant?.name);
    return p?.service_code ? `${nome} (${p.service_code})` : nome;
  });
  if (itens.length <= 1) return itens.join("");
  return `${itens.slice(0, -1).join(", ")} e ${itens[itens.length - 1]}`;
};

// Bloco fixo do card da transcrição de casamento, em qualquer etapa.
export default function SobreTranscricao({ process, processes }) {
  if (process?.type !== "Transcrição de Casamento") return null;

  // Quem está apensado à pessoa da TR depende dela.
  const dependentes = (processes || []).filter(
    (p) =>
      p?.id !== process?.id &&
      p?.apensado_id != null &&
      String(p.apensado_id) === String(process?.applicant?.id)
  );

  return (
    <Container>
      <strong>Sobre a transcrição de casamento</strong>
      <p>
        <b>O que é.</b> Registra em Portugal o casamento de{" "}
        {primeiroNome(process?.applicant?.name)}, celebrado no Brasil. Sem esse
        registro, Portugal não reconhece o casamento.
      </p>
      <p>
        <b>Por que não tem senha.</b> Diferente dos pedidos de nacionalidade, a
        conservatória não abre consulta pública. Nós acompanhamos e avisamos.
      </p>
      <p>
        <b>O que sai no final.</b> O assento de casamento português, que fica
        disponível aqui.
      </p>
      {dependentes.length > 0 && (
        <p>
          <b>Quem depende dela.</b>{" "}
          {dependentes.length === 1
            ? `O pedido de ${listarPedidos(
                dependentes
              )} só pode ser concluído depois desta transcrição.`
            : `Os pedidos de ${listarPedidos(
                dependentes
              )} só podem ser concluídos depois desta transcrição.`}
        </p>
      )}
    </Container>
  );
}
